"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var classes_1 = require("../../classes");
function isCepValid() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!value) return new classes_1.ValidationResult(true);
  var onlyDigitsValues = value.match(/\d+/gi);
  var result = onlyDigitsValues ? onlyDigitsValues.join('') : null;
  if (result && !/^(.)\1+$/.test(value.replace(/[\D]/, ''))) {
    return new classes_1.ValidationResult(result.length === 8);
  }
  return new classes_1.ValidationResult(false);
}
exports.default = new classes_1.Validator(isCepValid);